import { render, staticRenderFns } from "./CalculoNomina.vue?vue&type=template&id=21535e38&scoped=true"
import script from "./CalculoNomina.vue?vue&type=script&lang=js"
export * from "./CalculoNomina.vue?vue&type=script&lang=js"
import style0 from "./CalculoNomina.vue?vue&type=style&index=0&id=21535e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21535e38",
  null
  
)

export default component.exports